import React, { Component } from 'react';
import './style.css';

class InputField extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: false,
      errorCode: '',
      fieldValue: props.value
    };
  }

  onValidate(event) {
    const validateResult = this.props.onValidate(this.state.fieldValue);
    if (validateResult) {
      this.setState({
        error: true,
        errorCode: validateResult
      });
      return false;
    }
    return true;
  }

  clearField() {
    this.setState({ fieldValue: '' });
  }

  onFocus() {
    this.setState({
      error: false,
      errorCode: ''
    });
  }

  onChange(event) {
    this.setState({ fieldValue: event.target.value });
    this.props.onChange(event);
  }

  render() {
    const {
      type,
      // value,
      disabled,
      classes,
      name,
      placeholder,
      tabIndex
    } = this.props;

    const styleList = classes ? classes.join(' ') : '';
    const errorStyle = this.state.error ? 'input-field__input_error' : '';
    return (
    <div>
      <input
        type={type}
        disabled={disabled}
        className={`input-field ${styleList} ${errorStyle}`}
        value={this.state.fieldValue}
        name={name}
        placeholder={placeholder}
        onChange={this.onChange.bind(this)}
        onBlur={this.onValidate.bind(this)}
        onFocus={this.onFocus.bind(this)}
        tabIndex={tabIndex}
      />
      {this.state.error ?
        <div className='input-field__error'>
          {this.state.errorCode}
        </div> : null
      }
    </div>
    );
  }
}

InputField.propTypes = {
  type: React.PropTypes.string,
  value: React.PropTypes.string,
  name: React.PropTypes.string.isRequired,
  placeholder: React.PropTypes.string,
  classes: React.PropTypes.arrayOf(React.PropTypes.string),
  disabled: React.PropTypes.bool,
  tabIndex: React.PropTypes.number,

  onBlur: React.PropTypes.func,
  onFocus: React.PropTypes.func,
  onChange: React.PropTypes.func
};

InputField.defaultProps = {
  type: 'text',
  value: '',
  placeholder: '',
  disabled: false,
  classes: [],

  onChange: () => {}
};

export default InputField;



// WEBPACK FOOTER //
// ./src/blocks/inputField/InputField.js